import { NgModule } from '@angular/core';
import { CONFIGS_OPTIONS_SYSTEM_CONFIGS } from '../application/token/confings.token';
import { systemConfigRepository } from './repository/http/system-config.repository';

@NgModule({
  providers: [
    {
      provide: CONFIGS_OPTIONS_SYSTEM_CONFIGS,
      useClass: systemConfigRepository,
    },
  ],
})
export class SystemConfigInfructureLayerModule {}
